import type { ResultFilterEnum, SampleStatusEnum } from '../types/types'
import { getResultFilterTitle, getStatusFilterTitle } from './sampleUtils'

export const sampleFieldLabels = {
  analysisTypeId: 'Analysetype',
  archiveClosedTimestamp: 'Arkiv lukket tidspunkt',
  archiveId: 'Arkiv-ID',
  archived: 'Arkivert',
  archivedDate: 'Arkivert tidspunkt',
  avdelingId: 'Avdeling',
  closedArchiveBy: 'Arkiv lukket av',
  comment: 'Kommentar',
  conclusion: 'Samlet resultat',
  createdDate: 'Opprettet tidspunkt',
  externalCreatedDate: 'Eksternt opprettet tidspunkt',
  externalReferenceId: 'Ekstern referanse',
  externalReferenceType: 'Ekstern referansetype',
  followUp: 'Oppfølging',
  followUpComment: 'Oppfølgingskommentar',
  fromDate: 'Uttaksdato fra',
  labId: 'Laboratorium',
  locationId: 'Uttakssted',
  matrixIds: 'Prøve av',
  nameRedacted: 'Navn anonymisert',
  oversightObjRef: 'Produsent',
  payload: 'Skjema',
  planId: 'Plan',
  planIds: 'Plan',
  point: 'Posisjon',
  productIds: 'Produkt',
  producerSearch: 'Produsent',
  regionId: 'Divisjon',
  registeredDate: 'Registreringsdato',
  result: 'Resultat',
  resultsClosedDate: 'Resultater lukket tidspunkt',
  sampleTypeId: 'Prøvetype',
  sampntTypeId: 'Uttaksstedtype',
  sampntTypeIds: 'Uttakssted',
  seksjonId: 'Seksjon',
  sentPayload: 'Sendt skjema',
  state: 'Status',
  status: 'Status',
  substanceIds: 'Analyser for',
  taskId: 'Oppgave',
  teamId: 'Team',
  takenDate: 'Uttaksdato',
  toDate: 'Uttaksdato til',
  userId: 'Bruker'
} as const

export const getSampleFieldLabel = (field: string): string => {
  return sampleFieldLabels[field as keyof typeof sampleFieldLabels] ?? field
}

export const getProducerSearchChipLabel = (producerSearch: string) => {
  const trimmed = producerSearch.trim()
  return /^\d+$/.test(trimmed) ? 'Produsentnummer' : 'Produsentnavn'
}

export const formatSampleFieldValue = (
  field: string,
  value: unknown
): string => {
  if (value == null || value === '') return '-'
  if (Array.isArray(value)) {
    return value.some((item) => item !== null && typeof item === 'object')
      ? JSON.stringify(value, null, 2)
      : value.join(', ')
  }
  if (typeof value === 'boolean') return value ? 'Ja' : 'Nei'
  if (typeof value === 'object') return JSON.stringify(value, null, 2)

  const valueString = String(value)
  if (field === 'conclusion') {
    const conclusions: Record<string, string> = {
      POSITIVE: 'Påvist',
      NEGATIVE: 'Ikke påvist',
      UNDETERMINED: 'Ikke vurdert'
    }
    return conclusions[valueString] ?? valueString
  }
  if (field === 'state' || field === 'status') {
    return getStatusFilterTitle(valueString as SampleStatusEnum)
  }
  if (field === 'result') {
    return getResultFilterTitle(valueString as ResultFilterEnum)
  }
  const trimmed = valueString.trim()
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    try {
      const parsed: unknown = JSON.parse(trimmed)
      if (parsed !== null && typeof parsed === 'object') {
        return JSON.stringify(parsed, null, 2)
      }
    } catch {
      // Preserve audit text that is not valid JSON.
    }
  }
  return valueString
}
